"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachClient = /*#__PURE__*/function () {
  function CoachClient(client) {
    (0, _classCallCheck2["default"])(this, CoachClient);
    this.client = client;
    this.resourceUrl = '/document';
  }

  (0, _createClass2["default"])(CoachClient, [{
    key: "getClientDocumentList",
    value: function getClientDocumentList(clientId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/client/").concat(clientId), args);
    }
  }, {
    key: "getClientDocumentListByPlanId",
    value: function getClientDocumentListByPlanId(clientId, planId, type) {
      var url = "".concat(this.resourceUrl, "/client/").concat(clientId, "/plan");

      if (type) {
        url += "?type=".concat(type);
      }

      if (planId) {
        url += "&planId=".concat(planId);
      }

      for (var _len2 = arguments.length, args = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "deleteClientDocument",
    value: function deleteClientDocument(clientId, documentId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client["delete"]("".concat(this.resourceUrl, "/").concat(documentId, "/client/").concat(clientId), args);
    }
  }, {
    key: "getDownloadDocumentUrl",
    value: function getDownloadDocumentUrl(clientId, documentId, type, documentName, contentType) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 5 ? _len4 - 5 : 0), _key4 = 5; _key4 < _len4; _key4++) {
        args[_key4 - 5] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(documentId, "/").concat(type, "/client/").concat(clientId, "/signed-url?fileType=").concat(contentType, "&fileName=").concat(documentName), args);
    }
  }, {
    key: "getSignUrlForUploadReportOfUser",
    value: function getSignUrlForUploadReportOfUser(contentType, clientId, reportType) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
        args[_key5 - 3] = arguments[_key5];
      }

      return this.client.post("/document/".concat(reportType, "/client/").concat(clientId, "/signed-url?fileType=").concat(contentType), args);
    }
  }, {
    key: "addReportForUser",
    value: function addReportForUser(clientId, reportType, reqObj) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
        args[_key6 - 3] = arguments[_key6];
      }

      return this.client.post("/document/".concat(reportType, "/client/").concat(clientId), reqObj, args);
    }
  }, {
    key: "getClientSimple360List",
    value: function getClientSimple360List(clientId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.get("/survey-request/client/".concat(clientId, "/first-simple-360"), args);
    }
  }]);
  return CoachClient;
}();

exports["default"] = CoachClient;